import { Navigate, createBrowserRouter } from "react-router-dom";
/**ADMIN ROUTE START */
import AdminLayout from "./modules/admin/shared/adminlayout";
import PrivateRoute from "./modules/admin/shared/privateRoute";
import PublicRoute from "./modules/admin/shared/publicRoute";
import Error404 from "./modules/admin/pages/404";
import Dashboard from "./modules/admin/pages/dashboard";
import EmailTemplatesTable from "./modules/admin/pages/cms/automaticemailtemplates/list";
import EmailTempAdd from "./modules/admin/pages/cms/automaticemailtemplates/add";
import EmailTempEdit from "./modules/admin/pages/cms/automaticemailtemplates/edit";
import ViewEmailTemp from "./modules/admin/pages/cms/automaticemailtemplates/view";
import PageTable from "./modules/admin/pages/cms/pages/list";
import PageAdd from "./modules/admin/pages/cms/pages/add";
import PageEdit from "./modules/admin/pages/cms/pages/edit";
import PageView from "./modules/admin/pages/cms/pages/view";
import GlobalSettings from "./modules/admin/pages/cms/settings/settings";
import WebAppSettings from "./modules/admin/pages/cms/web-app-settings/edit";
import BannerTable from "./modules/admin/pages/cms/banners/list";
import BannerAdd from "./modules/admin/pages/cms/banners/add";
import BannerEdit from "./modules/admin/pages/cms/banners/edit";
import BannerView from "./modules/admin/pages/cms/banners/view";
import AdminUnAuthLayout from "./modules/admin/shared/adminUnAuthLayout";
import WebsiteLayout from "./modules/website/shared/layout";
import WebsiteHomePage from "./modules/website/pages/homePage";
import FaqTable from "./modules/admin/pages/faq/list";
import FaqAdd from "./modules/admin/pages/faq/add";
import FaqEdit from "./modules/admin/pages/faq/edit";
import SubjectTable from "./modules/admin/pages/cms/subjects/list";
import SubjectAdd from "./modules/admin/pages/cms/subjects/add";
import SubjectEdit from "./modules/admin/pages/cms/subjects/edit";
import InquiryTable from "./modules/admin/pages/inquries/list";
import ViewInquiry from "./modules/admin/pages/inquries/view";

import EditProfile from "./modules/admin/pages/admin/editprofile";
import Changepassword from "./modules/admin/pages/admin/changepassword";
import Login from "./modules/admin/pages/auth/login";
import ForgotPwdPage from "./modules/admin/pages/auth/forgotpassword";
import OtpVerificationPage from "./modules/admin/pages/auth/otpverification";
import ResetPwdPage from "./modules/admin/pages/auth/resetpwd";
import CompleteAdminProfile from "./modules/admin/pages/admin/completeAdminProfile";
import Profile from "./modules/admin/pages/admin/profile";
import PurchasePurchasesHistoryList from "./modules/admin/pages/packageManagement/packagePurchaseHistory/list";
import Packages from "./modules/admin/pages/packageManagement/packages/list";
import AddPackages from "./modules/admin/pages/packageManagement/packages/add";
import EditPackages from "./modules/admin/pages/packageManagement/packages/edit";

import DynamicPages from "./modules/website/pages/dynamicPages";
import UsersList from "./modules/admin/pages/customer/list";
import SellersList from "./modules/admin/pages/selller/list";
import ViewCustomer from "./modules/admin/pages/customer/view";
import CustomerEdit from "./modules/admin/pages/customer/edit";
import ViewSeller from "./modules/admin/pages/selller/view";
import SellerEdit from "./modules/admin/pages/selller/edit";

// Buyer
import Home from "./modules/website/pages/Home";
import LoginBuyer from "./modules/user/pages/auth/Login";
import OtpBuyer from "./modules/user/pages/auth/Otp";
import Successfully from "./modules/user/pages/auth/Successfully";
import ResetPassword from "./modules/user/pages/auth/ResetPassword";
import SignupBuyer from "./modules/user/pages/auth/SignUp";
import Search from "./modules/user/pages/Search";
import LiveStreams from "./modules/user/pages/LiveStreams/List";
import LiveStreamDetail from "./modules/user/pages/LiveStreams/Detail";
import SellerDetails from "./modules/user/pages/LiveStreams/SellerDetails";
import ProductDetails from "./modules/user/pages/ProductDetails/Details";
import ProductsDetailsAdvertiser from "./modules/advertiser/pages/ProductDetails/Details";
import ProfileEdit from "./modules/user/pages/userProfile/EditProfile";
import ChangePassword from "./modules/user/pages/userProfile/ChangePassword";
import Favourites from "./modules/user/pages/Favourites";
import Shoplist from "./modules/user/pages/Shoplist";
import MyActivity from "./modules/user/pages/userProfile/MyActivity";
import NotificationSettings from "./modules/user/pages/userProfile/NotificationSettings";
import AboutUs from "./modules/user/pages/common/AboutUs";
import Faq from "./modules/user/pages/common/Faq";
import ContactUs from "./modules/user/pages/common/ContactUs";
import PrivacyPolicy from "./modules/user/pages/common/PrivacyPolicy";
import TermsAndConditions from "./modules/user/pages/common/TermsAndConditions";
import Notifications from "./modules/user/pages/userProfile/Notifications";
import AcceptInvite from "./modules/user/pages/auth/AcceptInvite";
import StaffInvitations from "./modules/user/pages/userProfile/StaffInvitations";
import AssignedStreams from "./modules/user/pages/userProfile/AssignedStreams";
import StaffLiveStream from "./modules/user/pages/userProfile/StaffLiveStream";
import StaffComments from "./modules/user/pages/userProfile/StaffComments";
import StaffProducts from "./modules/user/pages/userProfile/StaffProducts";
// Seller
import SelectRole from "./modules/advertiser/auth/SelectRole";
import LoginSeller from "./modules/advertiser/auth/LoginSeller";
import SignupSeller from "./modules/advertiser/auth/SignupSeller";
import ProfileSetup from "./modules/advertiser/auth/ProfileSetup";
import KycDetail from "./modules/advertiser/auth/KycDetail";
import SuccessfullySubmitted from "./modules/advertiser/auth/SuccessfullySubmitted";
import Dashbaord from "./modules/advertiser/pages/Dashbaord";
import Streams from "./modules/advertiser/pages/stream/Streams";
import StreamDetails from "./modules/advertiser/pages/stream/StreamDetails";
import UserStreamDetails from "./modules/user/pages/LiveStreams/StreamDetails";
import Products from "./modules/advertiser/pages/Products";
import ProfileSeller from "./modules/advertiser/pages/Profile";
import PurchaseLeads from "./modules/advertiser/pages/PurchaseLeads";
import MyTeam from "./modules/advertiser/pages/MyTeam";
import Invoice from "./modules/advertiser/pages/Invoice/Invoice";
import InvoiceDetail from "./modules/advertiser/pages/Invoice/InvoiceDetail";
import PackagesSeller from "./modules/advertiser/pages/package/Packages";
import PackagePurchaseHistory from "./modules/advertiser/pages/package/PackagePurchaseHistory";
import UserAuthLayout from "./modules/user/shared/userAuthLayout";
import UserPrivateRoute from "./modules/user/shared/userPrivateRoute";
import UserLayout from "./modules/user/shared/userLayout";
import UserPublicRoute from "./modules/user/shared/userPublicRoute";
import AdvertiserAuthLayout from "./modules/advertiser/shared/advertiserAuthLayout";
import AdvertiserPublicRoute from "./modules/advertiser/shared/advertiserPublicRoute";
import AdvertiserPrivateRoute from "./modules/advertiser/shared/advertiserPrivateRoute";
import AdvertiserLayout from "./modules/advertiser/shared/advertiserLayout";
import ForgotPassword from "./modules/user/pages/auth/ForgotPassword";
import OtpAdvertiser from "./modules/advertiser/auth/Otp";
import ForgotPasswordAdvertiser from "./modules/advertiser/auth/ForgotPassword";
import ResetPasswordAdvertiser from "./modules/advertiser/auth/ResetPassword";
import SignupOtpAdvertiser from "./modules/advertiser/auth/signupOtp";
import AdvertiserKycSetupRoute from "./modules/advertiser/shared/advertiserKycSetupRoute";
import AdvertiserProfileSetupRoute from "./modules/advertiser/shared/advertiserProfileSetupRoute";
import Categories from "./modules/admin/pages/productManagement/categories/list";
import ProductsDetails from "./modules/admin/pages/productManagement/products/list";
import ViewCategories from "./modules/admin/pages/productManagement/categories/view";
import AddCategories from "./modules/admin/pages/productManagement/categories/add";
import EditCategories from "./modules/admin/pages/productManagement/categories/edit";
import SubCategories from "./modules/admin/pages/productManagement/subcategories/list";
import ViewSubCategories from "./modules/admin/pages/productManagement/subcategories/view";
import AddSubCategories from "./modules/admin/pages/productManagement/subcategories/add";
import EditSubCategories from "./modules/admin/pages/productManagement/subcategories/edit";
import Attributes from "./modules/admin/pages/productManagement/attributes/list";
import AddAttributes from "./modules/admin/pages/productManagement/attributes/add";
import EditAttributes from "./modules/admin/pages/productManagement/attributes/edit";
import ViewAttributes from "./modules/admin/pages/productManagement/attributes/view";
import Colors from "./modules/admin/pages/productManagement/colors/list";
import AddColors from "./modules/admin/pages/productManagement/colors/add";
import EditColors from "./modules/admin/pages/productManagement/colors/edit";
import ViewColors from "./modules/admin/pages/productManagement/colors/view";
import PreSubCategories from "./modules/admin/pages/productManagement/presubcategories/list";
import ViewPreSubCategories from "./modules/admin/pages/productManagement/presubcategories/view";
import AddPreSubCategories from "./modules/admin/pages/productManagement/presubcategories/add";
import EditPreSubCategories from "./modules/admin/pages/productManagement/presubcategories/edit";

import Groupings from "./modules/admin/pages/productManagement/groupings/list";
import ViewGroupings from "./modules/admin/pages/productManagement/groupings/view";
import AddGroupings from "./modules/admin/pages/productManagement/groupings/add";
import EditGroupings from "./modules/admin/pages/productManagement/groupings/edit";

import ViewProducts from "./modules/admin/pages/productManagement/products/view";
import EditProduct from "./modules/admin/pages/productManagement/products/edit";
import StreamTable from "./modules/admin/pages/stream/list";
import LiveStream from "./modules/user/components/LiveStream";
import ViewStream from "./modules/user/components/ViewStream";
import LiveStreamDetails from "./modules/advertiser/pages/stream/LiveStreamDetails";
import PaymentList from "./modules/admin/pages/payment/list";
import ViewPayment from "./modules/admin/pages/payment/view";
import GeneralSeller from "./modules/admin/pages/selller/generalseller";
import SellerTransactions from "./modules/admin/pages/selller/transactions";
import ViewAdminStream from "./modules/admin/pages/stream/view";
import LeadsTable from "./modules/admin/pages/leads/list";
import ViewLeads from "./modules/admin/pages/leads/view";
import EditProfileTab from "./modules/admin/pages/selller/edit";
import BusinessProfileTab from "./modules/admin/pages/selller/businessProfile";
import StreamerProfile from "./modules/admin/pages/selller/StreamerProfile";
import KYCInformationTab from "./modules/admin/pages/selller/kycInformation";
import ProductReport from "./modules/admin/pages/reports/productReport/list";
import CustomerReportList from "./modules/admin/pages/reports/customerReport/list";
import StreamReportList from "./modules/admin/pages/reports/streamReport/list";
import PackageReport from "./modules/admin/pages/reports/packageReport/list";
import SubAdminList from "./modules/admin/pages/sub-admin/list";
import AddSubAdmin from "./modules/admin/pages/sub-admin/add";
import EditSubAdmin from "./modules/admin/pages/sub-admin/edit";
import ViewSubAdmin from "./modules/admin/pages/sub-admin/view";
import RoleList from "./modules/admin/pages/role/list";
import AddRole from "./modules/admin/pages/role/add";
import EditRole from "./modules/admin/pages/role/edit";
import FacebookCallback from "./modules/advertiser/pages/stream/FacebookCallback";

const router = createBrowserRouter([
  {
    path: "/",
    element: <WebsiteLayout />,
    children: [
      { path: "", element: <Home /> },

      // user routes
      { path: "user", element: <UserAuthLayout />, children: [
        { path: "login", element: <UserPublicRoute component={LoginBuyer} /> },
        { path: "otp", element: <UserPublicRoute component={OtpBuyer} /> },
        { path: "success", element: <UserPublicRoute component={Successfully} /> },
        { path: "forgot-password", element: <UserPublicRoute component={ForgotPassword} /> },
        { path: "reset-password", element: <UserPublicRoute component={ResetPassword} /> },
        { path: "signup", element: <UserPublicRoute component={SignupBuyer} /> },
      ]},
      { path: "user", element: <UserLayout />, children: [
        { path: "favourites", element: <UserPrivateRoute component={Favourites} /> },
        { path: "shoplist", element: <UserPrivateRoute component={Shoplist} /> },
        { path: "shoplists", element: <UserPrivateRoute component={Shoplist} /> },
        { path: "my-activity", element: <UserPrivateRoute component={MyActivity} /> },
        { path: "notification-settings", element: <UserPrivateRoute component={NotificationSettings} /> },
        { path: "notifications", element: <UserPrivateRoute component={Notifications} /> },
        { path: "profile-edit", element: <UserPrivateRoute component={ProfileEdit} /> },
        { path: "change-password", element: <UserPrivateRoute component={ChangePassword} /> },
        { path: "search", element: <Search /> },
        { path: "live-streams", element: <LiveStreams /> },
        { path: "live-streams/:publisherID/:roomID/:streamId", element: <LiveStreamDetail /> },
        { path: "live-streams/seller-details", element: <SellerDetails /> },
        { path: "product-details", element: <ProductDetails /> },
        { path: "streams/stream-details/:id", element: <UserStreamDetails /> },
        { path: "staff-invitations", element: <UserPrivateRoute component={StaffInvitations} /> },
        { path: "assigned-streams", element: <UserPrivateRoute component={AssignedStreams} /> },
        { path: "staff-stream/:streamId", element: <UserPrivateRoute component={StaffLiveStream} /> },
        { path: "staff-comments/:streamId", element: <UserPrivateRoute component={StaffComments} /> },
        { path: "staff-products", element: <UserPrivateRoute component={StaffProducts} /> },
      ]},

      // advertiser routes
      { path: "advertiser", element: <AdvertiserAuthLayout />, children: [
        { path: "login", element: <AdvertiserPublicRoute component={LoginSeller} /> },
        { path: "otp", element: <AdvertiserPublicRoute component={OtpAdvertiser} /> },
        { path: "success", element: <AdvertiserPublicRoute component={Successfully} /> },
        { path: "forgot-password", element: <AdvertiserPublicRoute component={ForgotPasswordAdvertiser} /> },
        { path: "reset-password", element: <AdvertiserPublicRoute component={ResetPasswordAdvertiser} /> },
        // { path: "signup", element: <AdvertiserPublicRoute component={SignupSeller} /> },
        { path: "otp-verification", element: <AdvertiserPublicRoute component={SignupOtpAdvertiser} /> },
        { path: "kyc-details", element: <AdvertiserKycSetupRoute component={KycDetail} /> },
        { path: "success-submitted", element: <SuccessfullySubmitted /> },
        { path: "profile-setup", element: <AdvertiserProfileSetupRoute component={ProfileSetup} /> },
      ]},
      { path: "advertiser", element: <AdvertiserLayout />, children: [
        { path: "favorites", element: <UserPrivateRoute component={Favourites} /> },
        { path: "shoplist", element: <UserPrivateRoute component={Shoplist} /> },
        { path: "dashboard", element: <UserPrivateRoute component={Dashbaord} /> },
        { path: "streams", element: <UserPrivateRoute component={Streams} /> },
        { path: "streams/live-streams/:userID/:roomID/:streamId", element: <UserPrivateRoute component={LiveStreamDetails} /> },
        { path: "streams/stream-details/:id", element: <UserPrivateRoute component={StreamDetails} /> },
        { path: "products", element: <UserPrivateRoute component={Products} /> },
        { path: "profile", element: <UserPrivateRoute component={ProfileSeller} /> },
        { path: "purchase-leads", element: <UserPrivateRoute component={PurchaseLeads} /> },
        { path: "my-team", element: <UserPrivateRoute component={MyTeam} /> },
        { path: "invoice", element: <UserPrivateRoute component={Invoice} /> },
        { path: "invoice-details", element: <UserPrivateRoute component={InvoiceDetail} /> },
        { path: "packages", element: <UserPrivateRoute component={PackagesSeller} /> },
        { path: "packages/purchase-history", element: <UserPrivateRoute component={PackagePurchaseHistory} /> },
        { path: "change-password", element: <UserPrivateRoute component={ChangePassword} /> },
        { path: "product-details", element: <UserPrivateRoute component={ProductsDetailsAdvertiser} /> },
      ]},
      { path: "businessprofilename/:handle", element: <UserLayout />, children: [
        { index: true, element: <SellerDetails /> }
      ]},
      { path: "business-profile-name/:handle", element: <UserLayout />, children: [
        { index: true, element: <SellerDetails /> }
      ]},
      { path: "advertiser/:handle", element: <UserLayout />, children: [
        { index: true, element: <SellerDetails /> }
      ]},

      // common routes
      { path: "select-role", element: <SelectRole /> },
      { path: "about-us", element: <AboutUs /> },
      { path: "faq", element: <Faq /> },
      { path: "contact-us", element: <ContactUs /> },
      { path: "privacy-policy", element: <PrivacyPolicy /> },
      { path: "terms-and-conditions", element: <TermsAndConditions /> },
      { path: "org-info/:slug", element: <DynamicPages /> },
      { path: "page/:slug", element: <DynamicPages /> },
      { path: "accept-invite", element: <AcceptInvite /> },
    ],
  },

  // admin routes
  {
    path: "admin",
    element: <PrivateRoute component={AdminLayout} />,
    children: [
      { path: "", element: <Navigate to="/admin/dashboard" /> },

      // Dashboard
      { path: "dashboard", element: <PrivateRoute component={Dashboard} slug="/admin/dashboard" /> },

      // Profile (no slug — accessible to all logged-in admins)
      { path: "profile", element: <PrivateRoute component={Profile} />, children: [
        { path: "edit/:id", element: <PrivateRoute component={EditProfile} /> },
        { path: "change-password/:id", element: <PrivateRoute component={Changepassword} /> },
      ]},

      // FAQ
      { path: "cms/faq-management/faq/list/:pgno", element: <PrivateRoute component={FaqTable} slug="/admin/cms/faq-management/faq/list" /> },
      { path: "cms/faq-management/faq/add", element: <PrivateRoute component={FaqAdd} slug="/admin/cms/faq-management/faq/add" /> },
      { path: "cms/faq-management/faq/:pgno/edit/:id", element: <PrivateRoute component={FaqEdit} slug="/admin/cms/faq-management/faq/edit" /> },

      // Subjects
      { path: "cms/subjects/list/:pgno", element: <PrivateRoute component={SubjectTable} slug="/admin/cms/subjects/list" /> },
      { path: "cms/subjects/add", element: <PrivateRoute component={SubjectAdd} slug="/admin/cms/subjects/add" /> },
      { path: "cms/subjects/:pgno/edit/:id", element: <PrivateRoute component={SubjectEdit} slug="/admin/cms/subjects/edit" /> },

      // CMS Pages
      { path: "cms/pages/list/:pgno", element: <PrivateRoute component={PageTable} slug="/admin/cms/pages/list" /> },
      { path: "cms/pages/add", element: <PrivateRoute component={PageAdd} slug="/admin/cms/pages/add" /> },
      { path: "cms/pages/:pgno/edit/:id", element: <PrivateRoute component={PageEdit} slug="/admin/cms/pages/edit" /> },
      { path: "cms/pages/view/:id", element: <PrivateRoute component={PageView} slug="/admin/cms/pages/list" /> },

      // Banners
      { path: "cms/banner/list/:pgno", element: <PrivateRoute component={BannerTable} slug="/admin/cms/banner/list" /> },
      { path: "cms/banner/add", element: <PrivateRoute component={BannerAdd} slug="/admin/cms/banner/add" /> },
      { path: "cms/banner/:pgno/edit/:id", element: <PrivateRoute component={BannerEdit} slug="/admin/cms/banner/edit" /> },
      { path: "cms/banner/view/:id", element: <PrivateRoute component={BannerView} slug="/admin/cms/banner/list" /> },

      // Settings
      { path: "cms/settings", element: <PrivateRoute component={GlobalSettings} slug="/admin/cms/settings" /> },
      { path: "cms/web-app", element: <PrivateRoute component={WebAppSettings} slug="/admin/cms/web-app" /> },

      // Email Templates
      { path: "cms/default-email-template/list/:pgno", element: <PrivateRoute component={EmailTemplatesTable} slug="/admin/cms/default-email-template/list" /> },
      { path: "cms/default-email-template/add", element: <PrivateRoute component={EmailTempAdd} slug="/admin/cms/default-email-template/edit" /> },
      { path: "cms/default-email-template/:pgno/edit/:id", element: <PrivateRoute component={EmailTempEdit} slug="/admin/cms/default-email-template/edit" /> },
      { path: "cms/default-email-template/view/:id", element: <PrivateRoute component={ViewEmailTemp} slug="/admin/cms/default-email-template/list" /> },

      // Package Management
      { path: "packageManagement/history/list", element: <PrivateRoute component={PurchasePurchasesHistoryList} slug="/admin/packageManagement/packages/list" /> },
      { path: "packageManagement/packages/list/:pgno", element: <PrivateRoute component={Packages} slug="/admin/packageManagement/packages/list" /> },
      { path: "packageManagement/packages/add", element: <PrivateRoute component={AddPackages} slug="/admin/packageManagement/packages/add" /> },
      { path: "packageManagement/packages/edit/:id", element: <PrivateRoute component={EditPackages} slug="/admin/packageManagement/packages/edit" /> },

      // Customers
      { path: "customers/list/:pgno", element: <PrivateRoute component={UsersList} slug="/admin/customers/list" /> },
      { path: "customers/view/:id", element: <PrivateRoute component={ViewCustomer} slug="/admin/customers/view" /> },
      { path: "customers/edit/:id", element: <PrivateRoute component={CustomerEdit} slug="/admin/customers/edit" /> },

      // Streamers
      { path: "streamers/list/:pgno", element: <PrivateRoute component={SellersList} slug="/admin/streamers/list" /> },
      { path: "streamers/pending/:pgno", element: <PrivateRoute component={SellersList} slug="/admin/streamers/list" /> },
      { path: "streamers/rejected/:pgno", element: <PrivateRoute component={SellersList} slug="/admin/streamers/list" /> },
      { path: "streamers/view/:id", element: <PrivateRoute component={GeneralSeller} slug="/admin/streamers/view" />, children: [
        { index: true, element: <PrivateRoute component={ViewSeller} slug="/admin/streamers/view" /> },
        { path: "transactions/:pgno", element: <PrivateRoute component={SellerTransactions} slug="/admin/streamers/view" /> },
      ]},
      { path: "streamers/edit/:id", element: <PrivateRoute component={StreamerProfile} slug="/admin/streamers/edit" />, children: [
        { path: "", element: <Navigate to="edit-profile" replace /> },
        { path: "edit-profile", element: <EditProfileTab /> },
        { path: "business-profile", element: <BusinessProfileTab /> },
        { path: "kyc-information", element: <KYCInformationTab /> },
      ]},

      // Inquiries
      { path: "inquiries/list/:pgno", element: <PrivateRoute component={InquiryTable} slug="/admin/inquiries/list" /> },
      { path: "inquiries/view/:id", element: <PrivateRoute component={ViewInquiry} slug="/admin/inquiries/view" /> },

      // Product Categories
      { path: "productManagement/categories/list/:pgno", element: <PrivateRoute component={Categories} slug="/admin/productManagement/categories/list" /> },
      { path: "productManagement/categories/view/:id", element: <PrivateRoute component={ViewCategories} slug="/admin/productManagement/categories/list" /> },
      { path: "productManagement/categories/add", element: <PrivateRoute component={AddCategories} slug="/admin/productManagement/categories/add" /> },
      { path: "productManagement/categories/edit/:id", element: <PrivateRoute component={EditCategories} slug="/admin/productManagement/categories/edit" /> },
      { path: "productManagement/subcategories/list/:pgno", element: <PrivateRoute component={SubCategories} slug="/admin/productManagement/subcategories/list" /> },
      { path: "productManagement/subcategories/view/:id", element: <PrivateRoute component={ViewSubCategories} slug="/admin/productManagement/subcategories/list" /> },
      { path: "productManagement/subcategories/add", element: <PrivateRoute component={AddSubCategories} slug="/admin/productManagement/subcategories/add" /> },
      { path: "productManagement/subcategories/edit/:id", element: <PrivateRoute component={EditSubCategories} slug="/admin/productManagement/categories/edit" /> },
      { path: "productManagement/presubcategories/list/:pgno", element: <PrivateRoute component={PreSubCategories} slug="/admin/productManagement/categories/list" /> },
      { path: "productManagement/presubcategories/view/:id", element: <PrivateRoute component={ViewPreSubCategories} slug="/admin/productManagement/categories/list" /> },
      { path: "productManagement/presubcategories/add", element: <PrivateRoute component={AddPreSubCategories} slug="/admin/productManagement/categories/add" /> },
      { path: "productManagement/presubcategories/edit/:id", element: <PrivateRoute component={EditPreSubCategories} slug="/admin/productManagement/categories/edit" /> },
      { path: "productManagement/attributes/list/:pgno", element: <PrivateRoute component={Attributes} slug="/admin/productManagement/attributes/list" /> },
      { path: "productManagement/attributes/add", element: <PrivateRoute component={AddAttributes} slug="/admin/productManagement/attributes/add" /> },
      { path: "productManagement/attributes/edit/:id", element: <PrivateRoute component={EditAttributes} slug="/admin/productManagement/categories/edit" /> },
      { path: "productManagement/attributes/view/:id", element: <PrivateRoute component={ViewAttributes} slug="/admin/productManagement/attributes/list" /> },
      { path: "productManagement/groupings/list/:pgno", element: <PrivateRoute component={Groupings} slug="/admin/productManagement/categories/list" /> },
      { path: "productManagement/groupings/view/:id", element: <PrivateRoute component={ViewGroupings} slug="/admin/productManagement/categories/list" /> },
      { path: "productManagement/groupings/add", element: <PrivateRoute component={AddGroupings} slug="/admin/productManagement/categories/add" /> },
      { path: "productManagement/groupings/edit/:id", element: <PrivateRoute component={EditGroupings} slug="/admin/productManagement/categories/edit" /> },
      { path: "productManagement/colors/list/:pgno", element: <PrivateRoute component={Colors} slug="/admin/productManagement/categories/list" /> },
      { path: "productManagement/colors/add", element: <PrivateRoute component={AddColors} slug="/admin/productManagement/categories/add" /> },
      { path: "productManagement/colors/edit/:id", element: <PrivateRoute component={EditColors} slug="/admin/productManagement/categories/edit" /> },
      { path: "productManagement/colors/view/:id", element: <PrivateRoute component={ViewColors} slug="/admin/productManagement/categories/list" /> },


      // Products
      { path: "productManagement/products/list/:pgno", element: <PrivateRoute component={ProductsDetails} slug="/admin/productManagement/products/list" /> },
      { path: "productManagement/products/view/:id", element: <PrivateRoute component={ViewProducts} slug="/admin/productManagement/products/view" /> },
      { path: "productManagement/products/edit/:id", element: <PrivateRoute component={EditProduct} slug="/admin/productManagement/products/edit" /> },

      // Stream
      { path: "stream/list/:pgno", element: <PrivateRoute component={StreamTable} slug="/admin/stream/list" /> },
      { path: "stream/view/:id", element: <PrivateRoute component={ViewAdminStream} slug="/admin/stream/view" /> },

      // Leads
      { path: "leads/list/:pgno", element: <PrivateRoute component={LeadsTable} slug="/admin/leads/list" /> },
      { path: "leads/view/:id", element: <PrivateRoute component={ViewLeads} slug="/admin/leads/view" /> },

      // Payment
      { path: "payment/list/:pgno", element: <PrivateRoute component={PaymentList} slug="/admin/payment/list" /> },
      { path: "payment/view/:id", element: <PrivateRoute component={ViewPayment} slug="/admin/payment/view" /> },

      // Reports
      { path: "reports/productReport/list/:pgno", element: <PrivateRoute component={ProductReport} slug="/admin/reports/productReport/list" /> },
      { path: "reports/customers/list/:pgno", element: <PrivateRoute component={CustomerReportList} slug="/admin/reports/customers/list" /> },
      { path: "reports/stream/list/:pgno", element: <PrivateRoute component={StreamReportList} slug="/admin/reports/stream/list" /> },
      { path: "reports/packageReport/list/:pgno", element: <PrivateRoute component={PackageReport} slug="/admin/reports/packageReport/list" /> },

      // Sub Admin Management (superAdminOnly)
      { path: "staff/list/:pgno", element: <PrivateRoute component={SubAdminList} superAdminOnly /> },
      { path: "staff/add", element: <PrivateRoute component={AddSubAdmin} superAdminOnly /> },
      { path: "staff/:pgno/edit/:id", element: <PrivateRoute component={EditSubAdmin} superAdminOnly /> },
      { path: "staff/view/:id", element: <PrivateRoute component={ViewSubAdmin} superAdminOnly /> },

      // Role Management (superAdminOnly)
      { path: "role/list/:pgno", element: <PrivateRoute component={RoleList} superAdminOnly /> },
      { path: "role/add", element: <PrivateRoute component={AddRole} superAdminOnly /> },
      { path: "role/list/:pgno/edit/:id", element: <PrivateRoute component={EditRole} superAdminOnly /> },
    ],
  },
  {
    path: "admin",
    element: <AdminUnAuthLayout />,
    children: [
      { path: "login", element: <PublicRoute component={Login} /> },
      { path: "forget-password", element: <PublicRoute component={ForgotPwdPage} /> },
      { path: "otp-verification/:email", element: <PublicRoute component={OtpVerificationPage} /> },
      { path: "reset-password", element: <PublicRoute component={ResetPwdPage} /> },
    ],
  },
  { path: "steps-preview/:slug", element: <DynamicPages /> },
  { path: "webservice/api/v1/advertiser/streams/facebook/callback", element: <FacebookCallback /> },
  { path: "*", element: <Error404 /> },
  { future: { v7_relativeSplatPath: true } },
]);

export default router;
